@if ((loadingService?.isLoading() | async) || visibleByCondition) {
  <div class="preloader-container">
    <div class="preloader">
      <div id="loader">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
}
